'use client'

import { useCallback, useMemo } from 'react'

import { useSession } from '@rewardops/auth/src/client'
import { useLocale } from '@rewardops/ui'

import { useApi } from '~/components/hooks/use-api'
import { AcEventParams } from './air-canada-types'
import { pushAcEvent } from './air-canada-utils'
import { fireAirCanadaMainHeaderEvent } from './events/fire-air-canada-main-header-event'

export const useAirCanadaEvent = () => {
  const { data: session, build, isLoading } = useSession()
  const { tenant } = useApi()
  const { language } = useLocale()

  const fireAirCanadaEvent = useCallback(
    (params: AcEventParams, includeEvent = true) => {
      if (!tenant || isLoading || !session || !session.user) {
        return false
      }

      const events = window.digitalDataAC?.events as any[]

      // If the main header event hasn't been fired yet, fire it
      if (events?.length < 2) {
        fireAirCanadaMainHeaderEvent({ tenant, session, build, language })
      }

      pushAcEvent(params, includeEvent)
      return true
    },
    [session, build, tenant, isLoading, language],
  )

  const memoizedFireAirCanadaEvent = useMemo(
    () => fireAirCanadaEvent,
    [fireAirCanadaEvent],
  )

  return { fireAirCanadaEvent: memoizedFireAirCanadaEvent }
}
